import React from "react";

import { styled } from "styled-components";

import { $AssetModel } from "@atlassiansox/bxp-content-framework";

import { Colors, radius, shadow, colorCSS, fontSizes } from "../../../styles";
import { redundantCssFromKebab } from "../../../styles/redundant-css";

export const Template = styled.a`
    ${redundantCssFromKebab("border-radius", `${radius.small}`)}
    ${redundantCssFromKebab("box-shadow", `${shadow.normal}`)}
    ${redundantCssFromKebab("color", "inherit")}
    ${redundantCssFromKebab("display", "block")}
    ${redundantCssFromKebab("height", "100%")}
    ${redundantCssFromKebab("margin", "0")}
    ${redundantCssFromKebab("overflow", "hidden")}
    ${redundantCssFromKebab("text-align", "left")}
    ${redundantCssFromKebab("text-decoration", "none")}
    ${redundantCssFromKebab("user-select", "none")}
    ${redundantCssFromKebab("white-space", "normal")}
    ${redundantCssFromKebab("width", "auto")}
    &:hover,
    &:focus {
        ${redundantCssFromKebab("box-shadow", `${shadow.dark}`)}
        ${redundantCssFromKebab("color", "inherit")}
    }
`;

export const TemplateHero: React.FC<Colors & { image?: string }> = ({
    background,
    image,
    linkColor,
    linkHoverColor,
    color,
    medium,
    headingColor,
    borderColor,
    ...props
}) => {
    const style: React.CSSProperties = {
        height: "6rem",
        ...(image
            ? {
                  backgroundImage: `url(${image}?w=1000)`,
                  backgroundSize: "cover"
              }
            : background
            ? {
                  background
              }
            : {})
    };
    return <div style={style} {...props} />;
};

export const ReducedTemplateHero: React.FC<Colors & { image?: string }> = ({
    background,
    image,
    linkColor,
    linkHoverColor,
    color,
    medium,
    headingColor,
    borderColor,
    ...props
}) => {
    const style: React.CSSProperties = {
        height: "2rem",
        backgroundSize: "cover",
        ...(image
            ? {
                  backgroundImage: `url(${image}?w=1000)`
              }
            : background
            ? {
                  background
              }
            : {})
    };
    return <div style={style} {...props} />;
};

export const TemplateAvatar = styled.div<{
    carousel?: boolean;
    image: $AssetModel;
    padding?: boolean;
}>(({ image, padding = false }) => ({
    backgroundColor: colorCSS("N0"),
    backgroundImage: image?.url ? `url(${image.url})` : "none",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    borderColor: colorCSS("N0"),
    borderRadius: radius.small,
    borderStyle: "solid",
    borderWidth: padding ? `8px` : `3px`,
    height: "3rem",
    left: "1rem",
    position: "absolute",
    top: "-1.5rem",
    width: "3rem"
}));

export const TemplateContent = styled.div`
    ${redundantCssFromKebab("padding", "2.25rem 1.5rem 1.5rem 1.5rem")}
    ${redundantCssFromKebab("position", "relative")}

    p {
        ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
        ${redundantCssFromKebab("margin", "0")}

        &.muted {
            ${redundantCssFromKebab("color", `${colorCSS("N300")}`)}
        }

        & + p {
            ${redundantCssFromKebab("margin-top", "0.5rem")}
        }
    }
`;
